import {OfferCommonFields, OfferFreeBadges, Option, Spec} from 'common/types';

export const FETCH_SPECS_REQUEST = '@common/fetch-specs-request';
export const FETCH_SPECS_SUCCESS = '@common/fetch-specs-success';
export const FETCH_SPECS_FAILURE = '@common/fetch-specs-failure';

export interface FetchSpecsAction {
  type: typeof FETCH_SPECS_REQUEST;
}

export interface FetchSpecsSuccessAction {
  type: typeof FETCH_SPECS_SUCCESS;
  payload: {
    specs: Spec[];
  };
}

export interface FetchSpecsFailureAction {
  type: typeof FETCH_SPECS_FAILURE;
  error: Error;
}

export const FETCH_ITEM_TYPES_REQUEST = '@common/fetch-item-types-request';
export const FETCH_ITEM_TYPES_SUCCESS = '@common/fetch-item-types-success';
export const FETCH_ITEM_TYPES_FAILURE = '@common/fetch-item-types-failure';

export interface FetchItemTypesAction {
  type: typeof FETCH_ITEM_TYPES_REQUEST;
}

export interface FetchItemTypesSuccessAction {
  type: typeof FETCH_ITEM_TYPES_SUCCESS;
  payload: {
    itemTypes: Option[];
  };
}

export interface FetchItemTypesFailureAction {
  type: typeof FETCH_ITEM_TYPES_FAILURE;
  error: Error;
}

export const FETCH_OPER_TYPES_REQUEST = '@common/fetch-oper-types-request';
export const FETCH_OPER_TYPES_SUCCESS = '@common/fetch-oper-types-success';
export const FETCH_OPER_TYPES_FAILURE = '@common/fetch-oper-types-failure';

export interface FetchOperTypesAction {
  type: typeof FETCH_OPER_TYPES_REQUEST;
}

export interface FetchOperTypesSuccessAction {
  type: typeof FETCH_OPER_TYPES_SUCCESS;
  payload: {
    operTypes: Option[];
  };
}

export interface FetchOperTypesFailureAction {
  type: typeof FETCH_OPER_TYPES_FAILURE;
  error: Error;
}

export const FETCH_OFFER_OPTIONS_REQUEST =
  '@common/fetch-offer-options-request';
export const FETCH_OFFER_OPTIONS_SUCCESS =
  '@common/fetch-offer-options-success';
export const FETCH_OFFER_OPTIONS_FAILURE =
  '@common/fetch-offer-options-failure';

export const FETCH_OFFER_FREE_BADGES_REQUEST =
  '@common/fetch-offer-free-badges-request';
export const FETCH_OFFER_FREE_BADGES_SUCCESS =
  '@common/fetch-offer-free-badges-success';
export const FETCH_OFFER_FREE_BADGES_FAILURE =
  '@common/fetch-offer-free-badges-failure';

export interface FetchOfferOptionsAction {
  type: typeof FETCH_OFFER_OPTIONS_REQUEST;
  payload: {
    itemType: number;
    operType: number;
    sectionMode?: number;
  };
}

export interface FetchOfferOptionsSuccessAction {
  type: typeof FETCH_OFFER_OPTIONS_SUCCESS;
  payload: {
    offerOptions: OfferCommonFields;
    requestKey: string;
  };
}

export interface FetchOfferOptionsFailureAction {
  type: typeof FETCH_OFFER_OPTIONS_FAILURE;
  error: Error;
}

export interface FetchOfferFreeBadgesAction {
  type: typeof FETCH_OFFER_FREE_BADGES_REQUEST;
  payload: {
    itemType?: number;
    operType?: number;
    cityId?: number;
  };
}

export interface FetchOfferFreeBadgesSuccessAction {
  type: typeof FETCH_OFFER_FREE_BADGES_SUCCESS;
  payload: {
    offerFreeBadges: OfferFreeBadges;
  };
}

export interface FetchOfferFreeBadgesFailureAction {
  type: typeof FETCH_OFFER_FREE_BADGES_FAILURE;
  error: Error;
}

export type CommonAction =
  | FetchSpecsAction
  | FetchSpecsSuccessAction
  | FetchSpecsFailureAction
  | FetchItemTypesAction
  | FetchItemTypesSuccessAction
  | FetchItemTypesFailureAction
  | FetchOperTypesAction
  | FetchOperTypesSuccessAction
  | FetchOperTypesFailureAction
  | FetchOfferOptionsAction
  | FetchOfferOptionsSuccessAction
  | FetchOfferOptionsFailureAction
  | FetchOfferFreeBadgesAction
  | FetchOfferFreeBadgesSuccessAction
  | FetchOfferFreeBadgesFailureAction;
